// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";

// @mui icons
import Icon from "@mui/material/Icon";
import SignIn from "layouts/authentication/sign-in";
import UserManagement from "layouts/user";
import UserDetails from "layouts/user/userDetail";
import PostManagement from "layouts/post";
import PostDetails from "layouts/post/postDetails";
import EditPost from "layouts/post/editPost";
import AdminPostManagement from "layouts/adminPost";
import AdminPostDetails from "layouts/adminPost/adminPostDetails";
import MainCategoryManagement from "layouts/mainCategory";
import SubCategoryManagement from "layouts/subCategory";
import ChildCategoryManagement from "layouts/childCategory";
import SubscriptionPlanManagement from "layouts/subscriptionPlan";
import ExtraPlanManagement from "layouts/extraPlan";
import UserContactManagement from "layouts/userContact";
import UserContactDetails from "layouts/userContact/userContactDetail";
import PaymentList from "layouts/payment";
import MetalPriceManagement from "layouts/metalPrice";
import NewsManagement from "layouts/news";
import NewsDetails from "layouts/news/newsDetail";
import HomepageBannerManagement from "layouts/homepageBanner";
import NotificationManagement from "layouts/notification";
import RateManagement from "layouts/rate";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/users",
    component: <UserManagement />,
  },
  {
    type: "none",
    name: "Users Details",
    key: "users-details",
    route: "/users-details/:id",
    component: <UserDetails />,
  },
  {
    type: "collapse",
    name: "Posts",
    key: "posts",
    icon: <Icon fontSize="small">article</Icon>,
    route: "/posts",
    component: <PostManagement />,
  },
  {
    type: "collapse",
    name: "Admin Post",
    key: "admin-post",
    icon: <Icon fontSize="small">article</Icon>,
    route: "/admin-post",
    component: <AdminPostManagement />,
  },
  {
    type: "none",
    name: "Admin Post Details",
    key: "admin-post-details",
    route: "/admin-post-details/:id",
    component: <AdminPostDetails />,
  },
  {
    type: "none",
    name: "Posts Details",
    key: "posts-details",
    route: "/post-details/:id",
    component: <PostDetails />,
  },
  {
    type: "none",
    name: "Edit Post",
    key: "edit-post",
    route: "/edit-post/:id",
    component: <EditPost />,
  },
  {
    type: "collapse",
    name: "MainCategory",
    key: "maincategory",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/maincategory",
    component: <MainCategoryManagement />,
  },
  {
    type: "collapse",
    name: "SubCategory",
    key: "subcategory",
    icon: <Icon fontSize="small">subdirectory_arrow_right</Icon>,
    route: "/subcategory",
    component: <SubCategoryManagement />,
  },
  {
    type: "collapse",
    name: "Child Category",
    key: "childcategory",
    icon: <Icon fontSize="small">subdirectory_arrow_right</Icon>,
    route: "/childcategory",
    component: <ChildCategoryManagement />,
  },
  {
    type: "collapse",
    name: "Subscription Plan",
    key: "subscriptionplan",
    icon: <Icon fontSize="small">workspace_premium</Icon>,
    route: "/subscriptionplan",
    component: <SubscriptionPlanManagement />,
  },
  {
    type: "collapse",
    name: "Extra Plan",
    key: "extraplan",
    icon: <Icon fontSize="small">extension</Icon>,
    route: "/extraplan",
    component: <ExtraPlanManagement />,
  },
  {
    type: "collapse",
    name: "User Contact",
    key: "usercontact",
    icon: <Icon fontSize="small">contact_page</Icon>,
    route: "/usercontact",
    component: <UserContactManagement />,
  },
  {
    type: "none",
    name: "User Contact Details",
    key: "usercontact-details",
    route: "/usercontact-details/:id",
    component: <UserContactDetails />,
  },
  {
    type: "collapse",
    name: "Payment",
    key: "payment",
    icon: <Icon fontSize="small">payment</Icon>,
    route: "/payment",
    component: <PaymentList />,
  },
  {
    type: "collapse",
    name: "Metal Price",
    key: "metal-price",
    icon: <Icon fontSize="small">attach_money</Icon>,
    route: "/metal-price",
    component: <MetalPriceManagement />,
  },
  {
    type: "collapse",
    name: "Rate",
    key: "rate",
    icon: <Icon fontSize="small">show_chart</Icon>,
    route: "/rate",
    component: <RateManagement />,
  },
  {
    type: "collapse",
    name: "News",
    key: "news",
    icon: <Icon fontSize="small">newspaper</Icon>,
    route: "/news",
    component: <NewsManagement />,
  },
  {
    type: "none",
    name: "News Details",
    key: "news-details",
    // icon: <Icon fontSize="small">news</Icon>,
    route: "/news-details/:id",
    component: <NewsDetails />,
  },
  {
    type: "collapse",
    name: "Homepage Banner",
    key: "homepage-banner",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/homepage-banner",
    component: <HomepageBannerManagement />,
  },
  {
    type: "collapse",
    name: "Notification",
    key: "notification",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notification",
    component: <NotificationManagement />,
  },
];

export const authRoutes = [
  {
    path: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;
